const MAX_SIX_DIGITS_REGEX = /^\d{1,6}$/

export const maxSixDigits = (value: string): boolean => {
  return MAX_SIX_DIGITS_REGEX.test(value) || value === ''
}
